// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2HrNg","footer":"Form_footer__2yH8j"};